import util from '@bmp-vue/core/api/util'

const controller = 'ApiResources'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'post', 'put', 'persist']))
